type Row = Record<string, unknown>;
const asRow = (value: unknown): Row | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Row : null;
const upper = (value: unknown): string => String(value ?? '').trim().toUpperCase();

export function definitionFor(row: Row | null, encounter: Row | null, id: string): Row | null {
  const full = (entry: unknown): Row | null => { const def = asRow(entry); return def && asRow(def.items) && (def.item_layer_types || def.computed) ? def : null; };
  const key = upper(id);
  return full(asRow(row?.catalog)?.[key]) ?? full(asRow(encounter?.catalog)?.[key]) ?? full(window.FateTide?.objectCache?.get(key)) ?? full(window.FateTide?.objectCache?.get(id)) ?? null;
}
